module.exports = __webpack_public_path__ + "img/why_attend.33f21079.png";